import React, { useEffect, useState } from "react";
import clsx from "clsx";
import type { TocItem } from "../shared/types";
import { COPY } from "../copy";

/** "On this page" (design §0.2): the page's H2 and H3, following the scroll. */
export const Toc = ({ items }: { items: TocItem[] }) => {
  const [active, setActive] = useState<string | null>(items[0]?.id ?? null);

  useEffect(() => {
    if (typeof IntersectionObserver === "undefined" || items.length === 0) return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((e) => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) setActive(visible[0].target.id);
      },
      { rootMargin: "-80px 0px -70% 0px" }
    );
    items.forEach((item) => {
      const el = document.getElementById(item.id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [items]);

  if (items.length === 0) return null;

  return (
    <nav aria-label={COPY.onThisPage} className="text-bodySmall">
      <p className="mb-2 font-semibold text-foreground">{COPY.onThisPage}</p>
      <ul className="space-y-1">
        {items.map((item) => (
          <li key={item.id} className={clsx(item.depth === 3 && "pl-3")}>
            <a href={`#${item.id}`} className={clsx("block py-0.5", active === item.id ? "text-purpleGreen" : "text-muted-foreground hover:text-foreground")}>
              {item.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};
